module.exports = __webpack_public_path__ + "img/ld-bg.1cccaf37.jpg";